export * from './src/restaurants-menus-v1-item-variant-item-variants.meta.js';
